import { DeclarationDetailsResponse } from "@shared/api/declarations/types"
import { create } from "zustand"
import { immer } from "zustand/middleware/immer"

type State = {
	declarationDetails: DeclarationDetailsResponse | undefined
	isBannerVisible: boolean
}

type Actions = {
	setDeclarationDetails: (details: DeclarationDetailsResponse) => void
	closeBanner: () => void
	resetStore: () => void
}

const initialState: State = {
	declarationDetails: undefined,
	isBannerVisible: false,
}

export const useDeclarationBannerStore = create<State & Actions>()(
	immer(set => ({
		...initialState,

		setDeclarationDetails: (details: DeclarationDetailsResponse) => {
			set(state => {
				state.declarationDetails = details
				state.isBannerVisible = true
			})
		},

		closeBanner: () => {
			set(state => {
				state.isBannerVisible = false
			})
		},

		resetStore: () => {
			set(state => {
				state.declarationDetails = undefined
				state.isBannerVisible = false
			})
		},
	})),
)
